import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import 'wowjs/css/libs/animate.css'
import animated from 'animate.css'
import echarts from 'echarts'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './assets/css/font/font.css'
import VueLazyload from 'vue-lazyload';
import Progress from 'vue-multiple-progress'
Vue.use(Progress)

import VueI18n from 'vue-i18n'

Vue.use(VueLazyload) // 挂载
Vue.use(VueI18n) // 挂载

Vue.prototype.$echarts = echarts

Vue.use(animated)

Vue.config.productionTip = false;
// ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI); 

// 预览大图
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999,
        inline: false,
        button: true,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        backdrop:true,
    }
})

// 语言国际化
let i18n = new VueI18n({
    locale: sessionStorage['locale'] ? sessionStorage['locale'] : 'cn',
    //数据
    messages: {
        'cn': require('./assets/locales/cn'),
        'en': require('./assets/locales/en'),
    }
})

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
